import { Comment } from '../../userApi';
import { State } from '../state';

export const commentCreator = (comment: Comment, state: State) => {
  if (comment.createdBy === state.user.id) {
    return state.user;
  }
  return state.users[comment.createdBy];
};
